<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-customer"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Item' : 'Tambah Item' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputSelect v-model="itemId" id="category-select" label="Item" :options="optionItems"
          placeholder="Pilih item" :valid="validation.item_id.valid"
          :error-message="validation.item_id.message" />
        <InputText type="number" v-model="qty" id="item-price" label="Qty" input_class="w-full"
          :valid="validation.qty.valid" :error-message="validation.qty.message" />
        <!-- <InputRupiah v-model="itemPurchasePrice" id="item-purchase-price" label="Harga" input_class="w-full"
          :valid="validation.purchase_price.valid" :error-message="validation.purchase_price.message" /> -->
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-primary hover:bg-hover-primary text-white"
            @click="submitSalesReturnDetail" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions, mapGetters } from 'vuex';
import InputSelect from '../form/InputSelect.vue';
import InputText from '../form/InputText.vue';

export default {
  name: "ModalSalesReturnDetail",
  props: {
    salesReturnDetail: {
      type: Object,
      default: null,
    },
    parentItemId: {
      type: Number,
      required: true,
    },
  },
  components: {
    SubmitButton, InputText, InputSelect
  },
  data() {
    return {
      showModal: true,
      itemId: this.salesReturnDetail ? this.salesReturnDetail.item_id : null,
      qty: this.salesReturnDetail ? this.salesReturnDetail.qty : 0,
      optionItems: [],
      optionUnits: [],
      isEdit: !!this.salesReturnDetail,
      validation: {
        item_id: {
          valid: true,
          message: ''
        },
        qty: {
          valid: true,
          message: ''
        },
      },
      field: ['item_id', 'qty'],
    }
  },
  computed: {
    ...mapGetters('items', ['allItems']),
    ...mapGetters('units', ['allUnits'])
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('items/fetchItems', { limit: 1000 }),
      this.$store.dispatch('units/fetchUnits', { limit: 1000, status: 'active' }),
    ]);
    this.optionItems = this.allItems.map(item => ({ label: item.name, value: item.id }))
    this.optionUnits = this.allUnits.map(unit => ({ label: unit.name, value: unit.id }));
  },
  watch: {
    salesReturnDetail(newVal) {
      if (newVal) {
        this.itemId = newVal.item_id;
        this.qty = newVal.qty;
        this.isEdit = true;
      } else {
        this.itemId = null;
        this.qty = 0;
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('sales_return_details', ['createSalesReturnDetail', 'updateSalesReturnDetail']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitSalesReturnDetail() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postSalesReturnDetail();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
    async postSalesReturnDetail() {
      try {
        const salesReturnDetailData = {
          sales_return_id: this.parentItemId,
          item_id: this.itemId,
          qty: this.qty,
        };

        if (this.isEdit && this.salesReturnDetail) {
          salesReturnDetailData.id = this.salesReturnDetail.id;
          await this.updateSalesReturnDetail(salesReturnDetailData);
        }
        else {
          await this.createSalesReturnDetail(salesReturnDetailData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>